export default __webpack_public_path__ + "static/media/defient_challenge_bg.png.webp";